import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomepagelocalNigeriaService } from '../countryhomenigeria.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-security-section',
  templateUrl: './security.component.html',
  imports: [CommonModule, ToHtmlPipe],
  styleUrls: ['./security.component.scss'],
})
export class SecuritySectionComponent implements OnInit {
  @Input() pageData:any;
  constructor(private homePageService: HomepagelocalNigeriaService) {}

  securityData: any;

  ngOnInit(): void {
    const data = this.pageData?.contentPanel?.[0]?.fields;
    if (data) {
      this.securityData = data;
    }
  }
  ngOnChanges(): void {
    const data = this.pageData?.contentPanel?.[0]?.fields;
    if (data) {
      this.securityData = data;
    }
  }
}
